// extracted by mini-css-extract-plugin
export default {"contact":"content_contact__3TqPv","title":"content_title__DqJ3H","body":"content_body__937Ej","infoTitle":"content_infoTitle__F7rfq","infoItem":"content_infoItem__q0KOh"};